import { createReducer, on } from '@ngrx/store';
import { Story } from '../../models';
import * as utility from '../../../utility';
import * as StoryActions from '../actions/stories.action';
import { PageData } from 'src/app/core/models';

export interface StoriesState {
  entities: { [id: number]: Story };
  sortOrder: number;
  page: PageData;
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  saved: boolean;
  error?: any;
}

export const initialState: StoriesState = {
  entities: {},
  sortOrder: 0,
  page: { currentPage: 0, pageCount: 0, resultCount: 0, pageSize: 12, filters: {} },
  loaded: false,
  loading: false,
  saved: false,
  saving: false,
};

export const StoryReducer = createReducer(
  initialState,
  on(StoryActions.LoadStories, StoryActions.LoadMoreStories, (state: StoriesState) => {
    return {
      ...state,
      loading: true,
      mineLoaded: false,
    };
  }),
  on(StoryActions.LoadStoriesSuccess, (state: StoriesState, { stories }) => {
    const entities = utility.ToEntities(stories.items, 'id', {});

    return {
      ...state,
      entities,
      page: stories.page,
      loading: false,
      loaded: true,
    };
  }),
  on(StoryActions.LoadMoreStoriesSuccess, (state: StoriesState, { stories }) => {
    const entities = utility.ToEntities(stories.items, 'id', state.entities);

    return {
      ...state,
      entities,
      page: stories.page,
      loading: false,
      loaded: true,
      mineLoaded: true,
    };
  }),
  on(StoryActions.LoadStoriesFail, (state: StoriesState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      mineLoaded: false,
      error,
    };
  }),
  on(StoryActions.LoadStory, (state: StoriesState, { id }) => {
    const entity: Story = {
      ...state.entities[id],
      loading: true,
      loaded: false,
    };

    return {
      ...state,
      entities: {
        ...state.entities,
        [id]: entity,
      },
    };
  }),
  on(StoryActions.LoadStorySuccess, (state: StoriesState, { story }) => {
    return {
      ...state,
      entities: {
        ...state.entities,
        [story.id]: story,
      },
    };
  }),
  on(StoryActions.CreateStory, StoryActions.UpdateStory, (state: StoriesState) => {
    return {
      ...state,
      saved: false,
      saving: true,
    };
  }),
  on(StoryActions.CreateStorySuccess, StoryActions.UpdateStorySuccess, (state: StoriesState, { story }) => {
    const entities = {
      ...state.entities,
      [story.id]: story,
    };
    return {
      ...state,
      entities,
      saved: true,
      saving: false,
    };
  }),
  on(StoryActions.DeleteStorySuccess, (state: StoriesState, { story }) => {
    const { [story.id]: removed, ...entities } = state.entities;
    return {
      ...state,
      entities,
      saved: true,
      saving: false,
    };
  }),
  on(StoryActions.SetSortOrder, (state: StoriesState, { order }) => {
    return {
      ...state,
      sortOrder: order,
    };
  }),
  on(StoryActions.ClearStories, (state: StoriesState) => {
    return {
      ...initialState,
    };
  }),
  on(StoryActions.LikeStorySuccess, (state: StoriesState, { story }) => {
    const entities = {
      ...state.entities,
      [story.id]: {
        ...state.entities[story.id],
        likes: { ...story.likes },
      },
    };
    return {
      ...state,
      entities,
    };
  })
);

export const getStoriesEntities = (state: StoriesState) => state.entities;
export const getStoriesSortOrder = (state: StoriesState) => state.sortOrder;
export const getStoriesLoading = (state: StoriesState) => state.loading;
export const getStoriesLoaded = (state: StoriesState) => state.loaded;
export const getStorySaved = (state: StoriesState) => state.saved;
export const getStorySaving = (state: StoriesState) => state.saving;
export const getStoriesPage = (state: StoriesState) => state.page;
